import path from 'path';

import TwoLineData from '~components/data/interfaces/twoLineData';
import { ColDef } from '~components/dataGrids/interfaces/colDef';
import { GridColTypeEnum } from '~components/dataGrids/interfaces/gridColTypeEnum';
import { pagePathSegments } from '~constants';
import { BaseReference } from '~interfaces';

import DeviceModel from './deviceModel';
import DeviceState from './deviceState';

interface Device extends BaseReference {
	description: string;
	resourceGroupId?: string;
	resourceGroupName?: string;
	organisationId?: string;
	organisationName?: string;
	hardwareId: string;
	bluetoothName: string;
	state?: DeviceState | undefined;
	model: DeviceModel;
}

export interface DeviceExtended extends Device {
	isWallReader: boolean;
	showConnectivityProfileSettingButton: boolean;
}

export const extendDevice = (device: Device | undefined | null): DeviceExtended | undefined => {
	if (!device) {
		return undefined;
	}

	return {
		...device,
		isWallReader: ['SKDOEL03'].includes(device.model.name),
		showConnectivityProfileSettingButton: device.state?.connectivityProfile != undefined,
	};
};

export const deviceGridCols: Record<string, ColDef<Device>> = {
	deviceNameAndId: {
		field: 'deviceNameAndId',
		headerName: 'entities:device.labels.single',
		gridColType: GridColTypeEnum.TwoLineItem,
		valueGetter: (value: Device) => {
			return {
				primary: value.name,
				secondary: value.hardwareId,
			} satisfies TwoLineData;
		},
		linkPathGetter: (value: Device) => path.join(pagePathSegments.Devices, value.id),
		defaultShown: true,
	},
	organisationAndResourceGroup: {
		field: 'organisationAndResourceGroup',
		headerName: 'entities:assignment.labels.single',
		gridColType: GridColTypeEnum.TwoLineItem,
		valueGetter: (value: Device) => {
			return {
				primary: value.organisationName ?? value.organisationId ?? '',
				secondary: value.resourceGroupName ?? value.resourceGroupId ?? undefined,
			} satisfies TwoLineData;
		},
		linkPathGetter: (value: Device) =>
			value.organisationId ? path.join(pagePathSegments.Organisations, value.organisationId) : '',
		defaultShown: true,
	},
	battery: {
		field: 'state',
		headerName: 'entities:device.fields.battery',
		gridColType: GridColTypeEnum.Battery,
		valueGetter: (value: Device) => value?.state?.batteryState ?? 0,
		maxWidth: 100,
		minWidth: 100,
		defaultShown: true,
	},
	firmwareVersion: {
		field: 'firmwareVersion',
		headerName: 'entities:device.labels.firmwareVersion',
		gridColType: GridColTypeEnum.Regular,
		valueGetter: (value: Device) => value?.state?.firmware ?? '',
		defaultShown: true,
	},
	lastOnline: {
		field: 'lastReport',
		headerName: 'date:lastOnline',
		gridColType: GridColTypeEnum.LastOnline,
		valueGetter: (value: Device) => value?.state?.lastReport,
		minWidth: 230,
		defaultShown: true,
	},
};
export default Device;
